'use client';

import { PropsWithChildren, ReactNode } from 'react';
import { alpha, Box, Fade } from '@mui/material';

type Props = {
  active: boolean;
  overlay: ReactNode;
};

/**
 * Blurs the wrapped form behind a glass surface and renders the overlay
 * content on top of it while active. The form underneath stays inert so it
 * can't be interacted with through the overlay.
 */
const GlassOverlay = ({
  active,
  overlay,
  children,
}: PropsWithChildren<Props>) => (
  <Box sx={{ position: 'relative' }}>
    <Box inert={active || undefined}>{children}</Box>
    <Fade in={active} timeout={300} unmountOnExit>
      <Box
        sx={{
          position: 'absolute',
          inset: '-8px',
          zIndex: 2,
          display: 'flex',
          overflowY: 'auto',
          py: { xs: 4, md: 6 },
          borderRadius: 'inherit',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.65),
        }}
      >
        {/* Auto margins center the content without clipping it on overflow */}
        <Box sx={{ m: 'auto' }}>{overlay}</Box>
      </Box>
    </Fade>
  </Box>
);

export default GlassOverlay;
